















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button } from 'vant';
import { voteList } from '../api/index';
import SearchInput from '@/components/SearchInput.vue';
Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button);
@Component({
  components: {
    SearchInput,
  },
})
export default class VoteList extends Vue {
  @Prop() options!: any;
  @Prop() cid!: number | string;
  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  result = [];
  SearchData = '';
  switchPage = '';
  // 初使加载
  onLoad() {
    setTimeout(() => {
      voteList({
        page: this.page,
        search: this.SearchData,
      }).then((res: any) => this.fetchListData(res));
    });
  }
  fetchListData(res: any) {
    if (res.data === '') {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    this.$router.push({
      path: './Detail',
      query: { id: item.id },
    });
  }
  // search
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  startSearch() {
    console.log('开始');
    this.page = 1;
    this.getListData = [];
    setTimeout(() => {
      this.onLoad();
    }, 200);
  }
}
